var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV5Poste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -38.22,
    y: -21.57,
    width: 138.18,
    height: 138.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,55.74H61.6V10.5H2ZM54.55,14.69c-3.19,3.12-6,5.89-8.88,8.69-3.4,3.37-6.76,6.77-10.17,10.13a5.26,5.26,0,0,1-7.62.13C21.7,27.54,15.6,21.37,9.47,15.22a3.53,3.53,0,0,1-.31-.53ZM6.16,18.37l15,15-15,15ZM54.05,51.62H9.72l15.09-15.1a9.87,9.87,0,0,0,6.79,2.82A9.48,9.48,0,0,0,39,35.81L54.33,51.25l-.28.37m3.25-3.57L42.26,33l15-15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV5Poste);
export default __webpack_public_path__ + "static/media/v5_poste.aaf4ceae0e541df64dfccf7f983166f4.svg";
export { ForwardRef as ReactComponent };